import React from 'react';
import classnames from 'classnames';
import { title, breadcrumbs } from '../../PropTypes';
import withContext from '../../lib/withContext';
import Breadcrumbs from '../../components/Breadcrumbs';
import Layout from '../../components/Layout';
import { Logo } from '../../components/Logo';
import MainRow from '../../components/MainRow';
import Navicon from '../../components/Navicon';
import Title from '../../components/Title';
import './style.scss';

export const Lean = ({ title, breadcrumbs }) => {
    const showTitle = typeof title === 'string';

    return (
        <Layout className={classnames({ 'has-title': showTitle }, 'lean')}>
            <MainRow>
                <Navicon />
                <Logo />
                {showTitle && <Title>{title}</Title>}
                <Breadcrumbs breadcrumbs={breadcrumbs} />
            </MainRow>
        </Layout>
    );
};

Lean.propTypes = {
    title,
    breadcrumbs,
};

/**
 * @param {HeaderProps} props
 * @returns {React.ReactElement} Header
 */
export default withContext(Lean);
